import React from 'react';
import { SECTION_TITLES, LABELS } from './constants';
import {
  HeaderContainer,
  HeaderTitleGroup,
  DashboardTitle,
  DashboardSubtitle,
  StatusBadge,
} from './styles';

const HeaderSection: React.FC = () => {
  return (
    <HeaderContainer>
      <HeaderTitleGroup>
        <DashboardTitle>{SECTION_TITLES.ADMIN_DASHBOARD}</DashboardTitle>
        <DashboardSubtitle>{LABELS.SUBTITLE}</DashboardSubtitle>
      </HeaderTitleGroup>
      <StatusBadge color="success">{LABELS.SYSTEM_STATUS}</StatusBadge>
    </HeaderContainer>
  );
};

export default HeaderSection;
